import { render, staticRenderFns } from "./AddAttorneyModal.vue?vue&type=template&id=e7305966"
import script from "./AddAttorneyModal.vue?vue&type=script&lang=ts"
export * from "./AddAttorneyModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports